import {
  OtpChannelInfoModel,
  VerificationParameterModel,
} from "../../models/OtpVerificationModel";

export const OTP_LENGTH = 4;
export const OTP_MIN_LENGTH = OTP_LENGTH;
export const OTP_MAX_LENGTH = OTP_LENGTH;
export const OTP_PLACEHOLDER = "XXXX";

export const hasOtpValue = (value: string) => {
  const length = value.trim().length;
  return length >= OTP_MIN_LENGTH && length <= OTP_MAX_LENGTH;
};

export const normalizeVerificationParameter = (
  value: any
): VerificationParameterModel => ({
  email: Boolean(value?.email ?? value?.Email),
  mobile: Boolean(value?.mobile ?? value?.Mobile),
});

export const normalizeOtpChannelInfo = (value: any): OtpChannelInfoModel => ({
  ...normalizeVerificationParameter(value),
  maskedEmail: value?.maskedEmail ?? value?.MaskedEmail ?? null,
  maskedMobileNumber: value?.maskedMobileNumber ?? value?.MaskedMobileNumber ?? null,
});

export const hasAnyVerificationChannel = (value: VerificationParameterModel) =>
  Boolean(value.email || value.mobile);

export const getOtpDeliveryTargets = (value: OtpChannelInfoModel) => {
  const targets: string[] = [];

  if (value.mobile && value.maskedMobileNumber) {
    targets.push(value.maskedMobileNumber);
  }

  if (value.email && value.maskedEmail) {
    targets.push(value.maskedEmail);
  }

  return targets;
};

export const getMaskedOtpLabel = (label: string, maskedValue?: string | null) =>
  maskedValue ? `${label} (${maskedValue})` : label;
